module.exports = __webpack_public_path__ + "fonts/ToyotaDisplay_Bd.f451bd4.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaDisplay_Bd.woff2
// module id = vVD+
// module chunks = 13